// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq_textWithBreaks__fyHR\\+ {
  white-space: pre-line;
}

.faq_faqSection__eGCrJ {
  padding: clamp(40px, 8vw, 60px) clamp(1rem, 3vw, 2rem);
  background: #f5f7fb;
}
@media (max-width: 768px) {
  .faq_faqSection__eGCrJ {
    padding: clamp(30px, 6vw, 40px) clamp(0.75rem, 2.5vw, 1.5rem);
  }
}
@media (max-width: 480px) {
  .faq_faqSection__eGCrJ {
    padding: clamp(20px, 5vw, 30px) clamp(0.5rem, 2vw, 1rem);
  }
}

.faq_title__Dtj6t {
  font-size: clamp(1.5rem, 5vw, 2rem);
  font-weight: 700;
  color: #24346d;
  text-align: center;
  margin-bottom: clamp(24px, 5vw, 36px);
  line-height: 1.2;
}
@media (max-width: 768px) {
  .faq_title__Dtj6t {
    font-size: clamp(1.4rem, 6vw, 1.8rem);
    margin-bottom: clamp(20px, 4vw, 28px);
  }
}
@media (max-width: 576px) {
  .faq_title__Dtj6t {
    font-size: clamp(1.3rem, 7vw, 1.6rem);
    margin-bottom: clamp(16px, 3.5vw, 24px);
  }
}
@media (max-width: 480px) {
  .faq_title__Dtj6t {
    font-size: clamp(1.2rem, 8vw, 1.4rem);
  }
}

.faq_accordion__tKdFs {
  max-width: clamp(600px, 80vw, 900px);
  margin: 0 auto;
  width: 100%;
}
@media (max-width: 1024px) {
  .faq_accordion__tKdFs {
    max-width: clamp(500px, 85vw, 800px);
  }
}
@media (max-width: 768px) {
  .faq_accordion__tKdFs {
    max-width: clamp(400px, 90vw, 700px);
  }
}
@media (max-width: 576px) {
  .faq_accordion__tKdFs {
    max-width: 95vw;
  }
}
@media (max-width: 480px) {
  .faq_accordion__tKdFs {
    max-width: 98vw;
  }
}

.faq_item__P\\+4H0 {
  background: #fff;
  border-radius: clamp(12px, 2vw, 16px);
  margin-bottom: clamp(10px, 2vw, 14px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.faq_item__P\\+4H0:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .faq_item__P\\+4H0 {
    border-radius: clamp(10px, 2vw, 14px);
    margin-bottom: clamp(8px, 1.5vw, 12px);
  }
}
@media (max-width: 576px) {
  .faq_item__P\\+4H0 {
    border-radius: clamp(8px, 1.5vw, 12px);
    margin-bottom: clamp(6px, 1.2vw, 10px);
  }
}
@media (max-width: 480px) {
  .faq_item__P\\+4H0 {
    border-radius: 8px;
    margin-bottom: 8px;
  }
}

.faq_question__3qc1D {
  width: 100%;
  padding: clamp(14px, 3vw, 18px) clamp(16px, 3.5vw, 22px);
  background: none;
  border: none;
  font-size: clamp(0.95rem, 3vw, 1.125rem);
  font-weight: 600;
  color: #24346d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  text-align: left;
  line-height: 1.3;
}
.faq_question__3qc1D .faq_icon__qHdBj {
  transition: transform 0.25s ease;
  font-size: clamp(14px, 2.5vw, 16px);
  color: #24346d;
  flex-shrink: 0;
}
.faq_question__3qc1D .faq_icon__qHdBj.faq_open__cWvKN {
  transform: rotate(180deg);
}
@media (max-width: 768px) {
  .faq_question__3qc1D {
    font-size: clamp(0.9rem, 3.5vw, 1rem);
    padding: clamp(12px, 2.5vw, 16px) clamp(14px, 3vw, 18px);
  }
}
@media (max-width: 576px) {
  .faq_question__3qc1D {
    font-size: clamp(0.85rem, 4vw, 0.95rem);
    padding: clamp(10px, 2vw, 14px) clamp(12px, 2.5vw, 16px);
  }
}
@media (max-width: 480px) {
  .faq_question__3qc1D {
    font-size: clamp(0.8rem, 4.5vw, 0.9rem);
    padding: 12px 14px;
  }
}

.faq_answer__pe3xi {
  padding: clamp(12px, 2.5vw, 16px) clamp(16px, 3.5vw, 22px) clamp(16px, 3.5vw, 22px);
  font-size: clamp(0.85rem, 2.5vw, 0.9375rem);
  color: #444b74;
  line-height: 1.6;
  border-top: 1px solid #eef0f6;
}
@media (max-width: 768px) {
  .faq_answer__pe3xi {
    font-size: clamp(0.8rem, 3vw, 0.875rem);
    padding: clamp(10px, 2vw, 14px) clamp(14px, 3vw, 18px) clamp(14px, 3vw, 18px);
    line-height: 1.5;
  }
}
@media (max-width: 576px) {
  .faq_answer__pe3xi {
    font-size: clamp(0.75rem, 3.5vw, 0.8rem);
    padding: clamp(8px, 1.5vw, 12px) clamp(12px, 2.5vw, 16px) clamp(12px, 2.5vw, 16px);
  }
}
@media (max-width: 480px) {
  .faq_answer__pe3xi {
    font-size: clamp(0.7rem, 4vw, 0.75rem);
    padding: 10px 14px 14px;
    line-height: 1.5;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .faq_item__P\\+4H0,
  .faq_question__3qc1D,
  .faq_icon__qHdBj {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleHomePage/faq.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EAKE,sDAAA;EACA,mBAAA;AAHF;AAKE;EARF;IASI,6DAAA;EAFF;AACF;AAIE;EAZF;IAaI,wDAAA;EADF;AACF;;AAIA;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AADF;AAGE;EARF;IASI,qCAAA;IACA,qCAAA;EAAF;AACF;AAEE;EAbF;IAcI,qCAAA;IACA,uCAAA;EACF;AACF;AACE;EAlBF;IAmBI,qCAAA;EAEF;AACF;;AACA;EACE,oCAAA;EACA,cAAA;EACA,WAAA;AAEF;AAAE;EALF;IAMI,oCAAA;EAGF;AACF;AADE;EATF;IAUI,oCAAA;EAIF;AACF;AAFE;EAbF;IAcI,eAAA;EAKF;AACF;AAHE;EAjBF;IAkBI,eAAA;EAMF;AACF;;AAHA;EACE,gBAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,gBAAA;AAMF;AAJE;EACE,gBAAA;AAMJ;AAHE;EAXF;IAYI,qCAAA;IACA,sCAAA;EAMF;AACF;AAJE;EAhBF;IAiBI,sCAAA;IACA,sCAAA;EAOF;AACF;AALE;EArBF;IAsBI,kBAAA;IACA,kBAAA;EAQF;AACF;;AALA;EACE,WAAA;EACA,wDAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAQF;AANE;EACE,gCAAA;EACA,mCAAA;EACA,cAAA;EACA,cAAA;AAQJ;AANI;EACE,yBAAA;AAQN;AAJE;EA1BF;IA2BI,qCAAA;IACA,wDAAA;EAOF;AACF;AALE;EA/BF;IAgCI,uCAAA;IACA,wDAAA;EAQF;AACF;AANE;EApCF;IAqCI,uCAAA;IACA,kBAAA;EASF;AACF;;AANA;EACE,mFAAA;EACA,2CAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;AASF;AAPE;EAPF;IAQI,uCAAA;IACA,6EAAA;IACA,gBAAA;EAUF;AACF;AARE;EAbF;IAcI,wCAAA;IACA,kFAAA;EAWF;AACF;AATE;EAlBF;IAmBI,sCAAA;IACA,uBAAA;IACA,gBAAA;EAYF;AACF;;AATA,+BAAA;AACA;EACE;;;IAGE,gBAAA;EAYF;AACF","sourcesContent":[".textWithBreaks {\r\n  white-space: pre-line;\r\n}\r\n\r\n.faqSection {\r\n\r\n\r\n\r\n\r\n  padding: clamp(40px, 8vw, 60px) clamp(1rem, 3vw, 2rem);\r\n  background: #f5f7fb;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: clamp(30px, 6vw, 40px) clamp(0.75rem, 2.5vw, 1.5rem);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: clamp(20px, 5vw, 30px) clamp(0.5rem, 2vw, 1rem);\r\n  }\r\n}\r\n\r\n.title {\r\n  font-size: clamp(1.5rem, 5vw, 2rem);\r\n  font-weight: 700;\r\n  color: #24346d;\r\n  text-align: center;\r\n  margin-bottom: clamp(24px, 5vw, 36px);\r\n  line-height: 1.2;\r\n\r\n  @media (max-width: 768px) {\r\n    font-size: clamp(1.4rem, 6vw, 1.8rem);\r\n    margin-bottom: clamp(20px, 4vw, 28px);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    font-size: clamp(1.3rem, 7vw, 1.6rem);\r\n    margin-bottom: clamp(16px, 3.5vw, 24px);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    font-size: clamp(1.2rem, 8vw, 1.4rem);\r\n  }\r\n}\r\n\r\n.accordion {\r\n  max-width: clamp(600px, 80vw, 900px);\r\n  margin: 0 auto;\r\n  width: 100%;\r\n\r\n  @media (max-width: 1024px) {\r\n    max-width: clamp(500px, 85vw, 800px);\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    max-width: clamp(400px, 90vw, 700px);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    max-width: 95vw;\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    max-width: 98vw;\r\n  }\r\n}\r\n\r\n.item {\r\n  background: #fff;\r\n  border-radius: clamp(12px, 2vw, 16px);\r\n  margin-bottom: clamp(10px, 2vw, 14px);\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n  overflow: hidden;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    border-radius: clamp(10px, 2vw, 14px);\r\n    margin-bottom: clamp(8px, 1.5vw, 12px);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    border-radius: clamp(8px, 1.5vw, 12px);\r\n    margin-bottom: clamp(6px, 1.2vw, 10px);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    border-radius: 8px;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n\r\n.question {\r\n  width: 100%;\r\n  padding: clamp(14px, 3vw, 18px) clamp(16px, 3.5vw, 22px);\r\n  background: none;\r\n  border: none;\r\n  font-size: clamp(0.95rem, 3vw, 1.125rem);\r\n  font-weight: 600;\r\n  color: #24346d;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  line-height: 1.3;\r\n\r\n  .icon {\r\n    transition: transform 0.25s ease;\r\n    font-size: clamp(14px, 2.5vw, 16px);\r\n    color: #24346d;\r\n    flex-shrink: 0;\r\n\r\n    &.open {\r\n      transform: rotate(180deg);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    font-size: clamp(0.9rem, 3.5vw, 1rem);\r\n    padding: clamp(12px, 2.5vw, 16px) clamp(14px, 3vw, 18px);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    font-size: clamp(0.85rem, 4vw, 0.95rem);\r\n    padding: clamp(10px, 2vw, 14px) clamp(12px, 2.5vw, 16px);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    font-size: clamp(0.8rem, 4.5vw, 0.9rem);\r\n    padding: 12px 14px;\r\n  }\r\n}\r\n\r\n.answer {\r\n  padding: clamp(12px, 2.5vw, 16px) clamp(16px, 3.5vw, 22px) clamp(16px, 3.5vw, 22px);\r\n  font-size: clamp(0.85rem, 2.5vw, 0.9375rem);\r\n  color: #444b74;\r\n  line-height: 1.6;\r\n  border-top: 1px solid #eef0f6;\r\n\r\n  @media (max-width: 768px) {\r\n    font-size: clamp(0.8rem, 3vw, 0.875rem);\r\n    padding: clamp(10px, 2vw, 14px) clamp(14px, 3vw, 18px) clamp(14px, 3vw, 18px);\r\n    line-height: 1.5;\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    font-size: clamp(0.75rem, 3.5vw, 0.8rem);\r\n    padding: clamp(8px, 1.5vw, 12px) clamp(12px, 2.5vw, 16px) clamp(12px, 2.5vw, 16px);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    font-size: clamp(0.7rem, 4vw, 0.75rem);\r\n    padding: 10px 14px 14px;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n/* Accessibility improvements */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .item,\r\n  .question,\r\n  .icon {\r\n    transition: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textWithBreaks": `faq_textWithBreaks__fyHR+`,
	"faqSection": `faq_faqSection__eGCrJ`,
	"title": `faq_title__Dtj6t`,
	"accordion": `faq_accordion__tKdFs`,
	"item": `faq_item__P+4H0`,
	"question": `faq_question__3qc1D`,
	"icon": `faq_icon__qHdBj`,
	"open": `faq_open__cWvKN`,
	"answer": `faq_answer__pe3xi`
};
export default ___CSS_LOADER_EXPORT___;
